import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import Swal from "sweetalert2";

import { CustomBreadCrumb } from "../../components";
import { LessonForm } from "../../form";
import { LessonApi } from "../../api";
import { useAppNavigate, useAppParams } from "../../Router/hook";
import { Loading } from "../../components";
import { useAppSelector } from "../../redux-config/hooks";
import { selectUser } from "../../redux-config/entities/user";
import { SlideType } from "../../DTO";

export const LessonEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [lesson, setLesson] = useState<SlideType>();
    const navigate = useAppNavigate();

    const user = useAppSelector(selectUser);

    const { id } = useAppParams();

    const handleLessonEdit = (
        title: string,
        description: string,
        attachments: number[],
        timeToRead: number,
    ) => {
        setLoading(true);
        LessonApi.EditLesson(
            user,
            Number(id),
            title,
            description,
            timeToRead,
            attachments,
        )
            .then((data) => {
                navigate(`/lesson/list`);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    text: err,
                });
            });
    };

    useEffect(() => {
        fetchSingleLesson();
    }, [id]);

    const fetchSingleLesson = () => {
        setLoading(true);

        LessonApi.SlideApi.ListSlide(user, Number(id), 1)
            .then((data) => {
                setLesson(data.slides);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    text: err,
                });
            });
    };

    const crumbs = [
        { name: "", href: "" },
        { name: "Dashboard", href: "/" },
        { name: "Lesson list", href: "/lesson/list" },
        { name: "Edit" + id, href: "#" },
    ];

    return (
        <>
            <Helmet>
                <title>D2Type | Lesson Edit</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            {loading && <Loading />}
            <div className="d-flex flex-column">
                <CustomBreadCrumb breadCrumbList={crumbs} />
                <div className="d-flex flex-column bg-custom-white rounded p-3">
                    {lesson && (
                        <Formik<LessonForm.LessonSlideForm.FormValues>
                            validationSchema={
                                LessonForm.LessonSlideForm.ValidationSchema
                            }
                            initialValues={{
                                title: lesson.lesson.title,
                                content: lesson.lesson.attachments
                                    ? lesson.lesson.attachments
                                    : [],
                                description: lesson.lesson.description,
                                timeToRead: lesson.lesson.timeToRead,
                            }}
                            onSubmit={(event) => {
                                const imagesId: number[] = event.content.map(
                                    (element) => Number(element.id),
                                );
                                handleLessonEdit(
                                    event.title,
                                    event.description,
                                    imagesId,
                                    event.timeToRead,
                                );
                            }}
                            component={(props: any) => (
                                <LessonForm.LessonSlideForm.LessonSlideCreateOrEdit
                                    submitTxt={"Submit"}
                                    {...props}
                                />
                            )}
                        />
                    )}
                </div>
            </div>
        </>
    );
};
